import React from 'react';

const Greeting = () => {
    return (
        <div style={{marginLeft : '500px', marginTop : '50px'}}>
            <img src="https://media.tenor.com/images/a644f18dca84014665d900ccfeb5e070/tenor.gif" alt=""/>
        </div>
    );
};

export default Greeting;